module.exports = __webpack_public_path__ + "static/media/contemplative-reptile.34dfeed2.jpg";